const gdn_user_error_options = [
  { label: "Żle wykonane zdjęcie", value: "packer_incorrect_photo" },
  { label: "Inny błąd w zamówieniu", value: "packer_packing_other" },
  { label: "Produkty nadstanowe", value: "picker_over_packed" },
  { label: "Zły sposób zapakowania", value: "packer_badly_packed" },
  { label: "Podwójne COD", value: "packer_double_cod" },
  {
    label: "Niedostosowanie się do uwag zamówienia",
    value: "packer_skip_note",
  },
  { label: "Nadmiarowe produkty", value: "packer_extra_products" },
  {
    label: "Nieusunięcie błędnie nadanej etykiety",
    value: "packer_wrong_package_label_not_deleted",
  },
  {
    label: "Nieprzyniesienie paczki do kontroli",
    value: "packer_unreceived_packages_to_verify",
  },
];

export const gdn_line_user_error_options = [
  { label: "Błędny produkt", value: "packer_wrong_product" },
  { label: "Błędna ilość produktu", value: "packer_wrong_product_quantity" },
  { label: "Niekompletny produkt", value: "packer_incomplete_product" },
];

export const gdn_all_user_error_options = [
  { label: "Błędny produkt", value: "packer_wrong_product", kind: "packer" },
  {
    label: "Błędna ilość produktu",
    value: "packer_wrong_product_quantity",
    kind: "packer",
  },
  {
    label: "Uszkodzony produkt",
    value: "picker_broken_product",
    kind: "picker",
  },
  {
    label: "Niekompletny produkt",
    value: "picker_incomplete_product",
    kind: "picker",
  },
  {
    label: "Niekompletny produkt",
    value: "packer_incomplete_product",
    kind: "packer",
  },
  {
    label: "Żle wykonane zdjęcie",
    value: "packer_incorrect_photo",
    kind: "packer",
  },
  {
    label: "Inny błąd w zamówieniu",
    value: "packer_packing_other",
    kind: "packer",
  },
  {
    label: "Nadstanowe produkty",
    value: "picker_over_packed",
    kind: "picker",
  },
  {
    label: "Zły sposób zapakowania",
    value: "packer_badly_packed",
    kind: "packer",
  },
  { label: "Podwójne COD", value: "packer_double_cod", kind: "packer" },
  {
    label: "Niedostosowanie się do uwag zamówienia",
    value: "packer_skip_note",
    kind: "packer",
  },
  {
    label: "Nadmiarowe produkty",
    value: "packer_extra_products",
    kind: "packer",
  },
  {
    label: "Niepoprawnie zgłoszony brak",
    value: "picker_incorrect_missing",
    kind: "picker",
  },
  {
    label: "Nieusunięcie błędnie nadanej etykiety",
    value: "packer_wrong_package_label_not_deleted",
    kind: "packer",
  },
  {
    label: "Nieprzyniesienie paczki do kontroli",
    value: "packer_unreceived_packages_to_verify",
    kind: "packer",
  },
  {
    label: "Niezgłoszenie braku podczas kompletacji",
    value: "picker_missing_not_reported_during_picking",
    kind: "picker",
  },
];

export const getUserErrorName = (type) =>
  gdn_user_error_options.find(({ value }) => value === type)?.label;

export const getGdnLineUserErrorName = (type) =>
  gdn_line_user_error_options.find(({ value }) => value === type)?.label;

export const getAllUserErrorName = (type) =>
  gdn_all_user_error_options.find(({ value }) => value === type)?.label;

export default gdn_user_error_options;
